import { gql } from '@apollo/client'

export const CREATE_OR_UPDATE_ZONE = gql`
  mutation CreateOrUpdateZone($input: CreateOrUpdateZoneInput!) {
    createOrUpdateZone(input: $input) {
      zone {
        name
        id
        manager {
          fullName
          id
        }
      }
    }
  }
`
